<template lang="html">
  <div class="main">
    <div class="top-section">
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="12">
          <div class="container-section-title">
            <p class="section-title">Asesores</p>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="add-advisor-button">
            <div class="container-edit-text" v-on:click="dialogVisible = true">
              <i class="el-icon-plus"></i>
              <p>Crear cuenta</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="22">
        <el-main class="list-container">
          <el-table empty-text="Sin resultados" v-bind:data="advisors" style="">
            <el-table-column prop="name" label="Nombre" label-class-name="label-selector">
            </el-table-column>
            <el-table-column prop="email" label="Correo electrónico">
            </el-table-column>
            <el-table-column prop="index" width="60">
              <template slot-scope="scope">
                <el-dropdown trigger="click" placement="top">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-on:click.native="recoverPassword(scope.row.email)">Recuperar contraseña</el-dropdown-item>
                    <el-dropdown-item v-on:click.native="_deleteUser(scope.row.id)">Dar de baja</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-col>
    </el-row>
    <el-dialog title="Crear cuenta" :visible.sync="dialogVisible" :before-close="handleClose" >
      <div class="dialogo-card-content">
        <el-form :model="registryData" status-icon :rules="rules" ref="registryData">
          <el-form-item label="Nombre" prop="name">
            <el-input class="card-input" placeholder="" prefix-icon="el-icon-edit" v-model="registryData.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input class="card-input" placeholder="" prefix-icon="el-icon-edit" v-model="registryData.email" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="Contraseña" prop="password">
            <el-input class="card-input" placeholder="" prefix-icon="el-icon-edit" v-model="registryData.password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="Confirmar contraseña" prop="confirm_password">
            <el-input class="card-input" placeholder="" prefix-icon="el-icon-edit" v-model="registryData.confirm_password" auto-complete="off" :required="true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="validateAndSumbit('registryData')" style="width:100%; background-color:#2873DE; border:none">Crear cuenta</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- <div class="block">
    <el-pagination layout="prev, pager, next" :total="50">
    d
  </el-pagination>
</div> -->
</div>
</template>
<script>
import { getAllAdvisors, createAdvisor, deleteAdvisor, recoverPassword } from "@/graphql";

export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      registryData: {
        name: "",
        email: "",
        password: "",
        confirm_password: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "Debes proporcionar un nombre",
            trigger: "blur"
          },
          {
            min: 3,
            max: 30,
            message: "El nombre es demasiado corto",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "Debes proporcionar un email",
            trigger: "blur"
          },
          {
            type: "email",
            message: "Es necesario un email válido, ejemplo@email.com",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Debes proporcionar una contraseña",
            trigger: "blur"
          },
          {
            min: 3,
            message: "La contraseña es demasiado corta",
            trigger: "blur"
          },
          {
            max: 15,
            message: "La contraseña es demasiado larga",
            trigger: "blur"
          }
        ],
        confirm_password: [
          {
            required: true,
            validator: this.validateConfirmPassword,
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  computed: {
    advisors: function() {
      return this.$store.getters.advisorsData;
    }
  },
  mounted() {
    this.getAdvisors();
  },
  methods: {
    getAdvisors() {
      this.$apollo
        .query({
          query: getAllAdvisors,
          fetchPolicy: "network-only"
        })
        .then(data => this.successHandler(data.data.allAdvisors))
        .catch(error => {
          console.log(error);
        });
    },
    successHandler(advisors) {
      this.loading = false
      this.$store.dispatch("saveAdvisors", advisors);
    },
    validateConfirmPassword(rule, value, callback) {
      if (value === "" && value === this.registryData.password) {
        callback(new Error("Es necesario confirmar la contraseña"));
      } else if (value !== "" && value !== this.registryData.password) {
        callback(new Error("Las contraseñas no coinciden"));
      } else if (value !== "" && value === this.registryData.password) {
        callback();
      }
    },
    _deleteUser(advisorId) {
      this.$confirm(
        "Esto lo borrará permanentemente. ¿Continuar?",
        "Dar de baja asesor",
        {
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          type: "warning"
        }
      )
        .then(() => {
          this.deleteAdvisor(advisorId);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Acción cancelada"
          });
        });
    },
    handleClose(done) {
      this.$confirm("¿Seguro que quieres salir?", {
        confirmButtonText: "Si",
        cancelButtonText: "No"
      })
        .then(_ => {
          this.$refs["registryData"].resetFields();
          done();
        })
        .catch(_ => {});
    },
    validateAndSumbit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialogVisible = false;
          this.$apollo
            .mutate({
              mutation: createAdvisor,
              variables: {
                name: this.registryData.name,
                password: this.registryData.password,
                email: this.registryData.email
              }
            })
            .then(data => this.requestSuccess(data, "create"))
            .catch(() => {
              this.$message({
                type: "error",
                message: "Ocurrió un error intenta más tarde"
              });
            });
        } else {
          return false;
        }
      });
    },
    requestSuccess(data, action) {
      const successMessage =
        action === "create" ? "Asesor creado" : "Asesor eliminado";
      // console.log("Run this");
      if(action === "create") {
        this.$refs["registryData"].resetFields();
      }
      // console.log("Maybe not Run this");
      this.getAdvisors();
      this.$message({
        type: "success",
        message: successMessage
      });
    },
    deleteAdvisor(advisorId) {
      this.$apollo
        .mutate({
          mutation: deleteAdvisor,
          variables: {
            advisorId
          }
        })
        .then(data => this.requestSuccess(data, "delete"))
        .catch(() => {
          this.$message({
            type: "error",
            message: "Ocurrió un error, por favor intenta más tarde o contacta al admin"
          });
        });
    },
    recoverPassword(email) {
      this.$apollo.query({
        query: recoverPassword,
        variables: {
          email,
        }, fetchPolicy: 'network-only'
      }).then((data) =>
        this.$message({
          type: "success",
          message: data.data.recoverPassword.msg
        })
      )
    }
  }
};
</script>
<style scoped lang="css">
.el-table {
  display: block;
  margin: auto;
  padding: 0;
  font-size: 16px;
  text-align: left;
}

.main {
  display: block;
  width: 100%;
  box-sizing: border-box !important;
}

.el-main {
  line-height: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
}

.date-picker {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  padding: 10px;
}

.date-picker span {
  font-weight: bold;
}

.new-portfolio {
  text-decoration: none;
  padding: 10px;
  font-size: 14px;
  border: none;
  color: #303133;
}

.new-portfolio:active {
  background-color: #f5f5f5;
  outline: none;
}

.list-header {
  margin-bottom: 30px;
}

.el-icon-plus {
  margin-right: 5px;
  font-weight: bold;
  font-size: 20px;
}

.el-dropdown {
  display: block;
  margin: auto;
  width: 14px;
}

/* Blue button */

.blue-button {
  background-color: #4366de;
  color: white;
  text-align: center;
  height: 38px !important;
  cursor: pointer;
  border-radius: 3px;
}

.blue-button p {
  padding: 10px;
}

/* Style for bottom section */

.top-section {
  margin: 25px 0 38px 0;
}

.blue-extended-button {
  background-color: #4366de;
  color: white;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;
  display: inline-block;
  padding: 10px 0;
  position: relative;
  width: 100%;
  bottom: 3px;
}

.container-section-title {
  display: inline-block;
  position: relative;
  top: 6px;
}

.section-title {
  display: inline-block;
  font-weight: 500;
  font-size: 600;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  margin: 0 10px;
}

.blue-arrow-icon {
  font-size: 22px;
  font-weight: 600;
  color: #4366de;
  position: relative;
  top: 1px;
}

/* Style for Add comment section */

.add-advisor-button {
  cursor: pointer;
  background-color: #2873de;
  border-radius: 3px;
  color: white;
  width: 150px;
  float: right;
}

.container-edit-text {
  display: block;
  margin: 0 auto;
  width: 128px;
}

.container-edit-text i {
  display: inline-block;
  margin-right: 10px;
  position: relative;
  top: 1px;
}

.container-edit-text p {
  display: inline-block;
  padding: 9px 0;
}

a {
  text-decoration: none;
}

p {
  margin: 0px;
}
</style>

<style scoped media="screen">
/* Dialog card */

.el-dialog {
  width: 350px;
}

.el-form-item__label {
  font-weight: 500;
}

.el-form-item {
  margin: 0;
}

.el-form-item button {
  margin-top: 20px;
}

.el-form-item.is-error {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdvisorsTable.vue